











































































































import { Vue, Prop, Component, Watch, Ref } from "vue-property-decorator";
import {
  groupBy as _groupBy,
  debounce as _debounce,
  uniqBy as _uniqBy
} from "lodash";

@Component
export default class CSingleSelect extends Vue {
  @Prop() value?: any;
  @Prop() options?: Array<any>;
  @Prop() valueField?: any;
  @Prop({ default: 200 }) debounce?: number;
  @Prop() placeholder?: string;
  @Prop() inputPlaceholder?: string;
  @Prop({ default: "title" }) label!: string;
  @Prop() groupBy?: string;
  @Prop({ default: "enabled" }) fieldForCheckDisabled?: string;
  @Prop({ default: true }) isCanSelectDisabled?: boolean;
  @Prop({ default: true }) isShowDisabledEntity?: boolean; // only 'enabled' field
  @Prop({ default: true }) isMarkedDisableEntity?: boolean;
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: false }) disable?: boolean;
  @Prop() additionalField?: string;
  @Ref("list") myList: any;
  @Prop({ default: 60 }) maxLabelLength?: number;
  @Prop() filteredFields?: Array<string>;
  @Prop({ default: true }) deleteIconShow?: boolean;
  @Prop({ default: false }) arrowIconShow?: boolean;
  @Prop({ default: false }) unset!: boolean;

  search: string = "";
  selectedItem: any;
  isShowInput: boolean = false;
  items?: Array<any> = [];
  isShowListOnTop: boolean = false;
  localUnset: boolean = false;

  data() {
    return {
      selectedItem: undefined
    };
  }

  @Watch("unset")
  unsetValue() {
    this.localUnset = this.unset;
    try {
      if (this.localUnset) {
        this.search = "";
      }
    } finally {
      this.localUnset = false;
      this.$emit("value", this.localUnset);
    }
  }

  get checkGroup() {
    return this.groupBy ? this.filteredGroupedItems : 1;
  }

  get _placeholder() {
    return this.placeholder ?? this.$tc(this.$translate.NotSelected);
  }

  get filteredGroupedItems() {
    let searched: any = Object.assign({}, this.groupedObject);
    for (let key in searched) {
      if (searched.hasOwnProperty(key)) {
        searched[key] = searched[key].filter((el: any) =>
          el[this.label].toLowerCase().includes(this.search.toLowerCase())
        );
      }
    }
    return searched;
  }

  get filteredAllItems() {
    let searched = this.items?.filter(el => {
      return this.getDeep(el, this.label)
        .toLowerCase()
        .includes(this.search.toLowerCase());
    });

    this.filteredFields?.forEach(el => {
      let additionalFields = this.items?.filter(item => {
        return item?.[el]?.toLowerCase()?.includes(this.search.toLowerCase());
      });
      searched = searched?.length ? searched : [];
      additionalFields = additionalFields?.length ? additionalFields : [];

      searched = [...searched, ...additionalFields];
      searched = _uniqBy([...searched, ...additionalFields], "id");
    });

    return !this.isShowDisabledEntity
      ? searched?.filter(el => el.enabled)
      : searched;
  }

  get groupedObject() {
    return this.groupBy ? _groupBy(this.items, this.groupBy) : undefined;
  }

  get limitedLabel() {
    let label: any;
    label = this.getDeep(this.selectedItem, this.label);
    return label
      ? this.$converter.limitedOutput(
          label,
          this.maxLabelLength ? this.maxLabelLength : 60
        )
      : undefined;
  }

  get isHasLocalOptions() {
    return !!this.$slots?.default?.length;
  }

  get scrollDebounced() {
    return _debounce(this.checkScrollPosition, 500);
  }

  show() {
    this.isShowListOnTop = false;
    this.isShowInput = !this.isShowInput;
    const scrollHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );
    this.$nextTick(() => {
      if (this.isShowInput) {
        const listHeight = this.myList ? this.myList.offsetHeight : undefined;
        const listPositionBox = this.myList.getBoundingClientRect();
        const listPositionTop = listPositionBox.top + pageYOffset;

        if (listPositionTop + listHeight > scrollHeight) {
          this.isShowListOnTop = true;
        }
      }
    });
  }

  getListValue(item: any) {
    return this.groupBy ? item : this.filteredAllItems;
  }

  checkScrollPosition(event: any) {
    let cltHeight = event.target?.clientHeight;
    let scrHeight = event.target?.scrollHeight;
    let scrTop = event.target?.scrollTop;
    let percentage = ((cltHeight + scrTop) / scrHeight).toFixed(2);

    if (parseFloat(percentage) >= 0.9) {
      this.$emit("scrollEnd");
    }
  }

  select(item: any) {
    this.selectedItem = item;
    this.isShowInput = false;
    this.$emit("change", item);
  }

  checkDisabledEntity(item: any) {
    let check = true;
    let fieldForDisable = this.fieldForCheckDisabled
      ? this.fieldForCheckDisabled
      : undefined;

    if (
      this.isMarkedDisableEntity &&
      fieldForDisable &&
      item.hasOwnProperty(fieldForDisable)
    ) {
      check = item[fieldForDisable];
    }
    return check;
  }

  getDeep(obj: object, myPath: string | undefined) {
    return myPath
      ? myPath.split(".").reduce((res: any, prop: string) => {
          return res[prop] || res[prop] === 0 ? res[prop] : "";
        }, obj)
      : undefined;
  }

  getAdditionalField(item: any) {
    let label: any;
    label = this.getDeep(item, this.additionalField);
    return this.$converter.limitedOutput(label, 60);
  }

  getLabel(item: any) {
    return this.getDeep(item, this.label);
  }

  clearSelected() {
    this.selectedItem = undefined;
  }

  hide() {
    this.isShowInput = false;
  }

  getValue(item: any) {
    return item ? this.getDeep(item, this.valueField) : undefined;
  }

  setValue(value: any) {
    this.selectedItem = this.items?.find(el => {
      return this.valueField
        ? this.getDeep(el, this.valueField) === value
        : el === value;
    });
  }

  @Watch("isShowInput")
  checkShowInput() {
    if (this.isShowInput)
      this.$nextTick(() => {
        function scrollParentToChild(parent: any, child: any) {
          // Where is the parent on page
          let parentRect = parent.getBoundingClientRect();
          // What can you see?
          let parentViewableArea = {
            height: parent.clientHeight,
            width: parent.clientWidth
          };

          // Where is the child
          let childRect = child.getBoundingClientRect();
          // Is the child viewable?
          let isViewable =
            childRect.top >= parentRect.top &&
            childRect.bottom <= parentRect.top + parentViewableArea.height;

          // if you can't see the child try to scroll parent
          if (!isViewable) {
            // Should we scroll using top or bottom? Find the smaller ABS adjustment
            const scrollTop = childRect.top - parentRect.top;
            const scrollBot = childRect.bottom - parentRect.bottom;
            if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
              // we're near the top of the list
              parent.scrollTop += scrollTop;
            } else {
              // we're near the bottom of the list
              parent.scrollTop += scrollBot;
            }
          }
        }

        let active = this.myList.querySelector(`.active`);
        let list = this.myList.querySelector(`.list`);
        if (active && list) scrollParentToChild(list, active);
      });
  }

  @Watch("selectedItem")
  updCheck() {
    this.$emit("change", this.selectedItem);

    this.$emit(
      "input",
      this.valueField ? this.getValue(this.selectedItem) : this.selectedItem
    );
  }

  @Watch("search")
  upd() {
    this.$emit("search", this.search);
  }

  @Watch("value")
  updValue() {
    if (this.value === undefined && !this.isHasLocalOptions) {
      this.selectedItem = undefined;
    } else {
      this.setValue(this.value);
    }
  }

  @Watch("options", { immediate: true })
  updateList() {
    if (!this.isHasLocalOptions) {
      this.items = this.options?.length ? this.options : [];
    }
    this.setValue(this.value);
  }

  created() {
    let options: Array<any> | undefined = [];
    if (this.$slots.default) {
      options = this.$slots.default?.map((el: any) => {
        return {
          value: el.data?.attrs?.value,
          [this.label]: el.children[0].text
        };
      });
      this.items = options;
    }
    if (this.value) {
      this.setValue(this.value);
    }
  }
}
